import { I18N } from 'aurelia-i18n';
import { mock, instance, when, anything, verify } from 'ts-mockito';
import { Receipt } from './receipt';
import { PayrazrService } from '../../services/payrazr';
import {
	PortalTemplateTypes,
	ApplyCardSinglePaymentTemplateRequest,
	ApplyCheckSinglePaymentTemplateRequest,
	ApplyCardInstallmentPlanReceiptTemplateRequest,
	ApplyCheckInstallmentPlanReceiptTemplateRequest,
	ApplyCardRecurringPlanReceiptTemplateRequest,
	ApplyCheckRecurringPlanReceiptTemplateRequest,
	ApplyAutopayPlanReceiptTemplateRequest,
	TemplateService,
	ApplyTransactionFailedTemplateRequest
} from '../../services/template-service';

describe('NewPortalWeb', () => {
	describe('components', () => {
		describe('receipt', () => {
			let component: Receipt;
			const mockI18N: I18N = mock(I18N);
			const mockPayrazrService: PayrazrService = mock(PayrazrService);
			const mockTemplateService: TemplateService = mock(TemplateService);
			const mockElement: Element = mock(Element);

			const i18next = {
				t: (a, b) => a
			};

			beforeEach(() => {

				when(mockI18N.i18next).thenReturn(i18next);

				component = new Receipt(
					instance(mockElement),
					instance(mockPayrazrService),
					instance(mockTemplateService),
					instance(mockI18N),
				);
			});

			it('should initialize Confirmation component', () => {
				expect(component).toBeTruthy();
			});

			describe('attached()', () => {
				it('should call buildTemplateRequestAndCallApplyTemplate()', () => {
					spyOn(component, 'buildTemplateRequestAndCallApplyTemplate').and.stub();
					component.attached();
					expect(component.buildTemplateRequestAndCallApplyTemplate).toHaveBeenCalled();
				});
			});

			describe('buildTemplateRequestAndCallApplyTemplate()', () => {
				beforeEach(() => {
					component.pnref = 111;
					component.savedPaymentMethodToWallet = true;
					component.planId = 'P1234';
					component.merchantKey = 123;
					component.resultCode = 'Success';
					component.resultMessage = 'Successful';
					component.autopayKey = 321;
				});

				it('should set applyTemplateRequest as ApplyCardSinglePaymentTemplateRequest', () => {
					component.receiptType = PortalTemplateTypes.CreditCardSinglePaymentReceipt;
					spyOn(component, 'getTemplate').and.stub();

					component.buildTemplateRequestAndCallApplyTemplate();
					expect(component.applyTemplateRequest instanceof ApplyCardSinglePaymentTemplateRequest).toBeTruthy();
					expect(component.applyTemplateRequest.pnref).toBe(111);
					expect(component.applyTemplateRequest.savedPaymentMethodToWallet).toBe(true);
					expect(component.getTemplate).toHaveBeenCalled();
				});
				it('should set applyTemplateRequest as ApplyCheckSinglePaymentTemplateRequest', () => {
					component.receiptType = PortalTemplateTypes.CheckSinglePaymentReceipt;
					spyOn(component, 'getTemplate').and.stub();

					component.buildTemplateRequestAndCallApplyTemplate();
					expect(component.applyTemplateRequest instanceof ApplyCheckSinglePaymentTemplateRequest).toBeTruthy();
					expect(component.applyTemplateRequest.pnref).toBe(111);
					expect(component.applyTemplateRequest.savedPaymentMethodToWallet).toBe(true);
					expect(component.getTemplate).toHaveBeenCalled();
				});
				it('should set applyTemplateRequest as ApplyCardInstallmentPlanReceiptTemplateRequest', () => {
					component.receiptType = PortalTemplateTypes.CreditCardInstallmentPlanReceipt;
					spyOn(component, 'getTemplate').and.stub();

					component.buildTemplateRequestAndCallApplyTemplate();
					expect(component.applyTemplateRequest instanceof ApplyCardInstallmentPlanReceiptTemplateRequest).toBeTruthy();
					expect(component.applyTemplateRequest.planId).toBe('P1234');
					expect(component.applyTemplateRequest.merchantKey).toBe(123);
					expect(component.applyTemplateRequest.savedPaymentMethodToWallet).toBe(true);
					expect(component.getTemplate).toHaveBeenCalled();
				});
				it('should set applyTemplateRequest as ApplyCheckInstallmentPlanReceiptTemplateRequest', () => {
					component.receiptType = PortalTemplateTypes.CheckInstallmentPlanReceipt;
					spyOn(component, 'getTemplate').and.stub();

					component.buildTemplateRequestAndCallApplyTemplate();
					expect(component.applyTemplateRequest instanceof ApplyCheckInstallmentPlanReceiptTemplateRequest).toBeTruthy();
					expect(component.applyTemplateRequest.planId).toBe('P1234');
					expect(component.applyTemplateRequest.merchantKey).toBe(123);
					expect(component.applyTemplateRequest.savedPaymentMethodToWallet).toBe(true);
					expect(component.getTemplate).toHaveBeenCalled();
				});
				it('should set applyTemplateRequest as ApplyCardRecurringPlanReceiptTemplateRequest', () => {
					component.receiptType = PortalTemplateTypes.CreditCardRecurringPaymentPlanReceipt;
					spyOn(component, 'getTemplate').and.stub();

					component.buildTemplateRequestAndCallApplyTemplate();
					expect(component.applyTemplateRequest instanceof ApplyCardRecurringPlanReceiptTemplateRequest).toBeTruthy();
					expect(component.applyTemplateRequest.planId).toBe('P1234');
					expect(component.applyTemplateRequest.merchantKey).toBe(123);
					expect(component.applyTemplateRequest.savedPaymentMethodToWallet).toBe(true);
					expect(component.getTemplate).toHaveBeenCalled();
				});
				it('should set applyTemplateRequest as ApplyCheckRecurringPlanReceiptTemplateRequest', () => {
					component.receiptType = PortalTemplateTypes.CheckRecurringPaymentPlanReceipt;
					spyOn(component, 'getTemplate').and.stub();

					component.buildTemplateRequestAndCallApplyTemplate();
					expect(component.applyTemplateRequest instanceof ApplyCheckRecurringPlanReceiptTemplateRequest).toBeTruthy();
					expect(component.applyTemplateRequest.planId).toBe('P1234');
					expect(component.applyTemplateRequest.merchantKey).toBe(123);
					expect(component.applyTemplateRequest.savedPaymentMethodToWallet).toBe(true);
					expect(component.getTemplate).toHaveBeenCalled();
				});
				it('should set applyTemplateRequest as ApplyAutopayPlanReceiptTemplateRequest', () => {
					component.receiptType = PortalTemplateTypes.AutopayPlanReceipt;
					spyOn(component, 'getTemplate').and.stub();

					component.buildTemplateRequestAndCallApplyTemplate();
					expect(component.applyTemplateRequest instanceof ApplyAutopayPlanReceiptTemplateRequest).toBeTruthy();
					expect(component.applyTemplateRequest.autopayKey).toBe(321);
					expect(component.applyTemplateRequest.merchantKey).toBe(123);
					expect(component.applyTemplateRequest.savedPaymentMethodToWallet).toBe(true);
					expect(component.getTemplate).toHaveBeenCalled();
				});
				it('should set applyTemplateRequest as ApplyTransactionFailedTemplateRequest', () => {
					component.receiptType = PortalTemplateTypes.TransactionFailed;
					spyOn(component, 'getTemplate').and.stub();

					component.buildTemplateRequestAndCallApplyTemplate();
					expect(component.applyTemplateRequest instanceof ApplyTransactionFailedTemplateRequest).toBeTruthy();
					expect(component.applyTemplateRequest.resultCode).toBe('Success');
					expect(component.applyTemplateRequest.resultMessage).toBe('Successful');
					expect(component.applyTemplateRequest.savedPaymentMethodToWallet).toBe(true);
					expect(component.getTemplate).toHaveBeenCalled();
				});
			});

			describe('getTemplate()', () => {
				it('should call templateService.applyTemplate()', () => {
					when(mockTemplateService.applyTemplate(anything())).thenResolve({
						isSuccessful: true,
						resultMessage: '',
						value: undefined
					});

					component.getTemplate(anything());
					verify(mockTemplateService.applyTemplate(anything())).called();
				});
			});

			describe('doNext()', () => {
				it('should call clearQueryStringParams() and dispatchCustomEvent()', () => {
					spyOn(component, 'clearQueryStringParams').and.stub();
					spyOn(component, 'dispatchCustomEvent').and.stub();

					component.doNext();
					expect(component.clearQueryStringParams).toHaveBeenCalled();
					expect(component.dispatchCustomEvent).toHaveBeenCalled();
				});
			});

			describe('editTransaction()', () => {
				beforeEach(() => {
					component.editTransactionClickCount = 3;
					component.enableEditTransaction = true;
				});
				it('enableEditTransaction should be false after 3 retries', () => {
					spyOn(i18next, 't').and.returnValue('You have exceeded your retry attempts for this session.  Please confirm your payment information and try again later.');

					component.editTransaction();
					expect(component.enableEditTransaction).toBe(false);
					expect(component.customMessage).toBe('You have exceeded your retry attempts for this session.  Please confirm your payment information and try again later.');
				});
			});

			describe('editTransaction()', () => {
				beforeEach(() => {
					component.editTransactionClickCount = 0;
					component.enableEditTransaction = true;
				});

				it('enableEditTransaction should be true before 3 retries', () => {
					spyOn(component, 'dispatchCustomEvent').and.stub();
					spyOn(component, 'reset').and.stub();

					component.editTransaction();
					expect(component.enableEditTransaction).toBe(true);
					expect(component.dispatchCustomEvent).toHaveBeenCalled();
					expect(component.reset).toHaveBeenCalled();
				});
			});

			describe('editTransaction() reset() called', () => {
				beforeEach(() => {
					component.editTransactionClickCount = 0;
					component.enableEditTransaction = true;
				});

				it('reset function should be called', () => {
					spyOn(component, 'dispatchCustomEvent').and.stub();
					spyOn(component, 'reset').and.stub();

					component.editTransaction();
					expect(component.reset).toHaveBeenCalled();

					expect(component.customMessage).toBe('');
					expect(component.customerAccountNumber).toBe('');
					expect(component.resultCode).toBe('');
					expect(component.resultMessage).toBe('');
					expect(component.accountPayments).toBeNull();
					expect(component.content).toBeUndefined();
				});
			});

		});
	});
});
